<template>
	<div>
		<v-card
			class="profile-page pa-7 mt-8"
			style="border-radius: 10px; max-width: 600px;"
			flat
			v-if="user && renewUrl"
		>
			<v-card-text class="d-flex justify-space-between align-center">
				<p class='profile-full__label ma-0 mr-2 font-weight-bold'>{{ renewLabel }}</p>
				<a :href="renewUrl" target="_blank">
					<v-btn
						:loading="false" border="false" elevation="0"
						id="profile-full__renew-button"
						class="profile-full__button profile-full__renew-button"
					>
						{{ renewButtonName }}
					</v-btn>
				</a>
			</v-card-text>
		</v-card>

		<v-card
			class="profile-page pa-7 mt-8"
			style="border-radius: 10px; max-width: 600px;"
			flat
		>
			<v-card-text class="mt-5">
				<div class="user__brief-info-with-avatar d-flex my-10">
					<Avatar
						:avatar="avatarPath"
						size="140px"
						border-radius="square"
						class="user__avatar mr-10"
					/>

					<div class="user__brief-description">
						<h1 class="mb-3">{{userName}}</h1>

						<div class="d-flex flex-column">
							<span
								v-if="companyName"
								class="user__brief-description__company mb-1"
							>
								{{ companyName }}
							</span>
							<span
								v-if="heldPosition"
								class="user__brief-description__held-position mb-1"
							>
								{{heldPosition}}
							</span>
							<span
								v-if="location"
								class="user__brief-description__location mb-1"
							>
								<v-icon class="mr-1">mdi-map-marker</v-icon>
								<span>{{location}}</span>
							</span>
						</div>
					</div>
				</div>

				<v-skeleton-loader
					width="600"
					v-bind="attrs"
					type="card"
					v-if="false"
				>
				</v-skeleton-loader>
			</v-card-text>

			<router-link
				:to="{ name: 'profile'}"
			>
				<v-btn
					:loading="false" border="false" 
					elevation="0"
					class="profile-full__button"
				>
					View My Profile
				</v-btn>
			</router-link>
		</v-card>

		<v-card
			class="profile-page pa-7 mt-8"
			style="border-radius: 10px; max-width: 600px;"
			flat
		>
			<router-link
				:to="{ name: 'profile-bookmarks'}"
				class='text-decoration-none'
			>
				<v-card-text class="d-flex align-center font-weight-bold justify-space-between">
					<div class='d-flex align-center'>
						<div class='mr-6 icon-base rounded-circle'>
							<img :src="bookmarkIcon" alt=''>
						</div>
						<h2>Bookmarks</h2>
					</div>
					<h1 v-if="bookmarksMeta">{{ bookmarksMeta.totalCount }}</h1>
				</v-card-text>
			</router-link>
		</v-card>

		<v-card
			class="profile-page pa-7 mt-8"
			style="border-radius: 10px; max-width: 600px;"
			flat
		>
			<router-link
				:to="{ name: 'profile-notes'}"
				class='text-decoration-none'
			>
				<v-card-text class='d-flex align-center font-weight-bold justify-space-between'>
					<div class='d-flex align-center'>
						<div class='mr-6 icon-base rounded-circle'>
							<img :src="noteIcon" alt=''>
						</div>
						<h2>Notes</h2>
					</div>
					<h1 v-if="notesMeta">{{ notesMeta.totalCount }}</h1>
				</v-card-text>
			</router-link>
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import arrowIcon from '@/assets/images/resourcesIcon/arrow-icon.svg'
import bookmarkIcon from '@/assets/images/profile/bookmark.svg'
import noteIcon from '@/assets/images/profile/note.svg'
import Avatar from '@/components/Avatar';

export default {
	name: 'ProfilePreviewPage',
	components: {
		Avatar
	},
	computed: {
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('settings', ['user']),
		...mapGetters('profile', ['notesMeta', 'bookmarksMeta', 'notes']),

		allowFields() {
			const {[this.profileFieldsType]: profileFields} = this.profile

			return profileFields.reduce((prev, current) => {
				return {...prev, [current.field]: current}
			}, {});
		},
		renewLabel() {
			const { renew_area_text: value } = this.user || {}
			return value
		},
		renewButtonName() {
			const { renew_button_name: value } = this.user || {}
			return value
		},
		renewUrl() {
			const { renew_url: value } = this.user || {}
			return value
		},
		profileFieldsType() {
			if (!this.user) {
				return 'public';
			}

			const {view_profile_link: viewProfileLink} = this.user

			return this.getTypeFieldsFromUrl(viewProfileLink)
		},
		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},

		// short profile
		location() {
			const {location_profile_row: location = {}} = this.profile
			return location;
		},
		userName() {
			const {visible_username: name} = this.profile
			return name;
		},
		avatarPath() {
			const {user_logo: userLogo} = this.profile
			return userLogo;
		},
		heldPosition() {
			const {third_profile_row: heldPosition} = this.profile
			return heldPosition;
		},
		companyName() {
			const {second_profile_row: company} = this.profile
			return company;
		}
	},
	methods: {
		...mapActions('resources', ['getCategory', 'getCategoryResources']),
		...mapActions('profile', ['getProfileNotes', 'getProfileBookmarks']),
		...mapActions('settings', ['getUserSettings']),

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		dateCreated(originalDate) {
			return new Date(originalDate * 1000).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric'
			})
		},
		getTypeFieldsFromUrl(url) {
			const parts = url.split('/');
			return parts[parts.length - 1];
		}
	},
	data() {
		return {
			searchIcon,
			arrowIcon,
			bookmarkIcon,
			noteIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			socialFieldNames: [
				'user_linkedin',
				'user_facebook',
				'user_twitter',
				'user_custom_url'
			],
			phoneFieldNames: [
				'user_work_phone',
				'user_cell_phone'
			]
		}
	},
	beforeMount() {
		if (!this.user) {
			this.getUserSettings()
		}
		this.getProfileNotes()
		this.getProfileBookmarks()
	},
}
</script>

<style lang="scss">
.v-list-item {
	padding: 0;

	.v-icon {
		margin-right: 12px;
	}
}
.profile-page {
	font-family: Montserrat,sans-serif;

	.v-card__text {
		color: rgba(0, 0, 0, 0.6) !important;
	}
}
#profile-full__renew-button {
	background-color: var(--button-secondary-background-color) !important;
	color: var(--button-secondary-color) !important;
	text-transform: capitalize;
}
.profile-full {
	&__button {
		width: 100%;
		height: 45px !important;
		border-radius: 8px;
		font-weight: bold;
	}
	&__renew-button {
		width: fit-content;
	}
	&__label {
		font-size: 16px;
		font-weight: 700;
		color: var(--accent-color);
	}
}
.user {
	&__home-address,
	&__work-address {
		background: rgb(251, 251, 251);
		border-radius: 12px;
		border: 1px solid rgb(226, 226, 226);
	}
	&__brief-description {
		&__location {
			margin-left: -6px;
		}
	}
	&__phone-numbers > ul,
	&__networks > ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	@media screen and (max-width: 960px) {

	}
	@media screen and (max-width: 600px) {

	}
}

.icon-base {
	width: 45px;
	height: 45px;
	background-color: var(--accent-color);
	position: relative;

	img {
		width: 50%;

		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
